export default __webpack_public_path__ + "static/media/julia-costa-reis.739b7eb8.jpg";